import { Link } from 'react-router-dom';

export const LinkComposed = Link;

// Usage example:
// https://mui.com/material-ui/guides/routing/#link
/*
        <MuiLink
          component={LinkComposed}
          underline="hover"
          color="inherit"
          to="/about?name=test"
        />
*/
